const imageCardLight1 = "/assets/mvp/imageCardLight1.webp";
const imageCardLight2 = "/assets/mvp/imageCardLight2.webp";
const imageCardLight3 = "/assets/mvp/imageCardLight3.webp";
const imageCardLight4 = "/assets/mvp/imageCardLight4.webp";
const imageCardLight5 = "/assets/mvp/imageCardLight5.webp";
const imageCardLight6 = "/assets/mvp/imageCardLight6.webp";
const imageCardDark1 = "/assets/mvp/imageCardDark1.webp";
const imageCardDark2 = "/assets/mvp/imageCardDark2.webp";
const imageCardDark3 = "/assets/mvp/imageCardDark3.webp";
const imageCardDark4 = "/assets/mvp/imageCardDark4.webp";
const imageCardDark5 = "/assets/mvp/imageCardDark5.webp";
const imageCardDark6 = "/assets/mvp/imageCardDark6.webp";

const MvpData = [
  {
    icon: "/assets/mvp/img1.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "MVP Strategy",
    paragraph:
      "We help you define your core idea, map essential features, and create a clear, milestone-driven roadmap that ensures you start with the right scope.",
  },
  {
    icon: "/assets/mvp/img2.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "UX & Prototyping",
    paragraph:
      "We turn your concept into detailed user flows, wireframes, and clickable prototypes-allowing you to validate and refine your experience before development starts.",
  },
  {
    icon: "/assets/mvp/img3.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "Lean Development",
    paragraph:
      "We build only the essential features for your MVP using clean, scalable engineering practices, ensuring you launch fast without sacrificing long-term quality.",
  },
  {
    icon: "/assets/mvp/img4.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "Launch & Support",
    paragraph:
      "We handle deployment, environment setup, UAT cycles, and launch readiness, giving you a smooth release and ongoing support as real users begin engaging.",
  },
];

const points = [
  { content1: "Validate your idea with real users before investing heavily" },
  {
    content1: "Reduce development cost by focusing only on essential features",
  },
  {
    content1:
      "Launch faster with a clear, structured, milestone-driven process",
  },
  {
    content1: "Use early feedback to shape your product and attract investors",
  },
];

const ImageCardData = [
  {
    lightImg: imageCardLight1,
    darkImg: imageCardDark1,
    title: "Agile Development",
    topic: "FitTracker Pro",
    text: "Fitness tracking MVP with social features",
    frameworks: "React Native",
    tags: ["React Native", "Firebase", "Figma"],
  },
  {
    lightImg: imageCardLight2,
    darkImg: imageCardDark2,
    topic: "TaskFlow",
    text: "Team productivity platform for startups",
    frameworks: "React",
    tags: ["React", "Node.js", "MongoDB"],
  },
  {
    lightImg: imageCardLight3,
    darkImg: imageCardDark3,
    topic: "StyleSync",
    text: "Fashion discovery and styling app",
    frameworks: "Flutter",
    tags: ["Flutter", "AWS", "Sketch"],
  },
  {
    lightImg: imageCardLight4,
    darkImg: imageCardDark4,
    topic: "LocalConnect",
    text: "Community marketplace platform",
    frameworks: "PostgreSQL",
    tags: ["PostgreSQL", "Stripe", "Vue.js"],
  },
  {
    lightImg: imageCardLight5,
    darkImg: imageCardDark5,
    topic: "MindSpace",
    text: "Mental wellness and meditation app",
    frameworks: "React",
    tags: ["React", "GraphQL", "Docker"],
  },
  {
    lightImg: imageCardLight6,
    darkImg: imageCardDark6,
    topic: "InvestSmart",
    text: "Investment education and tracking tool",
    frameworks: "Angular",
    tags: ["Angular", "Python", "AI/ML"],
  },
];

const ProcessData = [
  {
    topic: "Discovery & Vision Alignment",
    description:
      "We understand your idea, define the core problem, and align on who the product is for.",
  },
  {
    topic: "Feature Prioritization",
    description:
      "We map the essential features for your MVP, focusing on what delivers impact in version one.",
  },
  {
    topic: "Design & Development",
    description:
      "We design intuitive user flows and build your MVP using modern, scalable technology.",
  },
  {
    topic: "Testing & Feedback",
    description:
      "We run UAT cycles, validate workflows, gather feedback, and refine the product for launch.",
  },
  {
    topic: "Launch & Support",
    description:
      "Your MVP goes live-stable, reliable, and ready for real users, with continued support.",
  },
];

const statsData = [
  { value: "6–10 Weeks", label: "Launch Timeline", valueColor: "#3950D1" },
  { value: "40–60%", label: "Cost Reduction", valueColor: "#9C00BB" },
  { value: "Weekly", label: "Demos & Updates", valueColor: "#0B9DCA" },
  { value: "100%", label: "Milestone Transparency", valueColor: "#5F4EA0" },
];

export { MvpData, points, ImageCardData, ProcessData, statsData };
